import { Redirect as RouterRedirect, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';

export const Redirect = (props) => {
  const { to, push = true } = props;
  const currentLocation = useLocation();
  const referrer = currentLocation.pathname + currentLocation.search;
  // console.log('🚀 ~ Redirect ~ currentLocation:', referrer);

  // render
  return (
    <RouterRedirect
      to={{
        pathname: to,
        // search: '?utm=your+face',
        state: { referrer: referrer },
      }}
      push={push}
    />
  );
};

Redirect.propTypes = {
  to: PropTypes.string.isRequired,
  push: PropTypes.bool,
};
